import React from 'react';

import * as S from './styles';

const Gallery05: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Photo1
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="200ms"
        />
        <S.Photo2
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        />
      </S.Wrapper>
      <S.Caption>
        <p>
          Conjuntos do verão 2023 de Thom Browne reinterpretam indumentária
          esportiva, dos surfistas (à esq.) aos tenistas (à dir.), distendendo
          as visões sobre o uniforme masculino. Getty Images
        </p>
      </S.Caption>
    </S.Container>
  );
};

export default Gallery05;
